
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

interface ChangeCredentialsDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onChangeCredentials: (username: string, password: string) => void;
}

const ChangeCredentialsDialog: React.FC<ChangeCredentialsDialogProps> = ({ isOpen, onOpenChange, onChangeCredentials }) => {
  const [newCredentials, setNewCredentials] = useState({ username: '', password: '', confirmPassword: '' });
  const [credentialsError, setCredentialsError] = useState('');

  const handleChangeCredentials = () => {
    setCredentialsError('');
    
    if (!newCredentials.username || !newCredentials.password) {
      setCredentialsError('Username and password are required');
      return;
    }
    
    if (newCredentials.password !== newCredentials.confirmPassword) {
      setCredentialsError('Passwords do not match');
      return;
    }
    
    onChangeCredentials(newCredentials.username, newCredentials.password);
    onOpenChange(false);
    setNewCredentials({ username: '', password: '', confirmPassword: '' });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Change Administrator Credentials</DialogTitle>
          <DialogDescription>
            Update your admin username and password.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="new-username">New Username</Label>
            <Input 
              id="new-username"
              value={newCredentials.username}
              onChange={(e) => setNewCredentials({...newCredentials, username: e.target.value})}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="new-password">New Password</Label>
            <Input 
              id="new-password"
              type="password"
              value={newCredentials.password}
              onChange={(e) => setNewCredentials({...newCredentials, password: e.target.value})}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm-password">Confirm Password</Label>
            <Input 
              id="confirm-password"
              type="password"
              value={newCredentials.confirmPassword}
              onChange={(e) => setNewCredentials({...newCredentials, confirmPassword: e.target.value})}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleChangeCredentials();
                }
              }}
            />
          </div>
          {credentialsError && (
            <p className="text-sm text-red-500">{credentialsError}</p>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleChangeCredentials} className="bg-brand-blue hover:bg-brand-darkBlue">
            Update Credentials
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeCredentialsDialog;
